export const getAutomaticLoginRootUrl = (rootUrl: string, token: string) => {
  const url = new URL(rootUrl);
  url.searchParams.set("automatic_login", "true");
  url.searchParams.set("token", token);

  return url.toString();
};
